type LoggedInFormInputType = {
  readonly isNewSiteInput: boolean;
};
type LoggedInFormInputActionType = {
  readonly type: string;
  readonly payload?: LoggedInFormInputType;
};

// Actions
const SET_FORM_INPUT = 'logged-in-form-input/SET_FORM_INPUT';

// Initial State
const initialState: LoggedInFormInputType = {
  isNewSiteInput: true
};

// Reducer
export const loggedInFormInputReducer = (
  state = initialState,
  action: LoggedInFormInputActionType
): LoggedInFormInputType => {
  switch (action.type) {
    case SET_FORM_INPUT:
      return Object.assign({}, state, {
        isNewSiteInput: action.payload?.isNewSiteInput
      });
    default:
      return state;
  }
};

// Action Creators
export function updateLoggedInFormInput(
  isNewSiteInput: boolean
): LoggedInFormInputActionType {
  return {
    type: SET_FORM_INPUT,
    payload: {
      isNewSiteInput
    }
  };
}
